import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const interviewStressResistance = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    stressResistanceScore: z
      .number()
      .nullable()
      .optional()
      .describe('Score for stress resistance.'),

    notes: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Interviewer notes on stress resistance.'),

    interviewId: z.number().hidden().describe('Foreign key to Interview'),

    interview: belongsTo('Interview'),
  })
  .describe('Stress resistance scores from the candidate interview.')
  .as('InterviewStressResistance');

export { interviewStressResistance as interviewStressResistanceSchema };
